// Order API
import ajax from './_ajax';

const api = {};
api.getTotalPoints = function () {
  return ajax.get('/api/Point/GetTotalPoints');
};
api.pointHistory = function (params) {
  return ajax.post('/api/Point/PointHistory', params);
};
export default api;



// WEBPACK FOOTER //
// ./src/api/pointApi.js